import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Text, Divider, Link } from '@ltvco/refresh-lib/theme';
import { useContext } from 'react';

import { PLAN_DISPLAY } from '../../constants';
import { SidebarCard } from '../components';

export const FAQ = () => {
  const {
    data: { supportPhone, supportEmail },
  } = useContext(AppConstants);

  return (
    <SidebarCard>
      <Text variant="h4" fontWeight={700} color="text.secondary">
        FAQ
      </Text>
      <Divider sx={{ my: 1 }} />
      <Text variant="h5" color="text.secondary" mb={1} mt={1}>
        BILLING DETAILS
      </Text>
      <Text variant="body1">
        *Cancel anytime by calling{' '}
        <Link
          href={`tel:${supportPhone}`}
          color="text.primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {supportPhone}
        </Link>
        , or online by simply emailing{' '}
        <Link
          href={`mailto:${supportEmail}`}
          color="text.primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {supportEmail}
        </Link>
        . Your 7-day membership trial is limited to running{' '}
        {PLAN_DISPLAY.monthlyLimit} reports during the trial period. After your
        7 day trial, you will be billed {PLAN_DISPLAY.recurringPrice} plus
        applicable sales tax per month and your plan will be limited to running{' '}
        {PLAN_DISPLAY.monthlyLimit} reports per month.
      </Text>
      <Divider sx={{ my: 1.5 }} />
      <Text variant="h5" color="text.secondary" mb={1} mt={1}>
        WHAT VEHICLES CAN I SEARCH?
      </Text>
      <Text variant="body1">
        Our data includes vehicles after 1981 when the standard 17-digit VIN was
        created. Automobiles, motorcycles, trucks, buses, motor homes and truck
        tractors may have vehicle history records. Unfortunately, we don't have
        history reports for tractors and trailers.{' '}
        <Link
          href="https://www.bumper.com/about/data/"
          color="text.primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more about Bumper's Vehicle Data.
        </Link>
      </Text>
    </SidebarCard>
  );
};
